import type { TRIReportDataType, TRISourceReductionActivityDataType } from '../../types/form-r.ts';
import type { CasOrCategory } from '../../types/db.ts';
import type { QuestionnaireAnswers } from '../../types/questionnaires.ts';
import type { Warning } from '../../types/tri.ts';

export function formRSection810SourceReductionActivities({
  chemicalName,
  casOrCategory,
  sourceReductionActivities,
  warnings,
}: {
  chemicalName: string;
  casOrCategory: CasOrCategory;
  sourceReductionActivities: QuestionnaireAnswers['sourceReductionActivities'];
  warnings: Warning[];
}): TRIReportDataType['SourceReduction'] {
  if (sourceReductionActivities.isApplicable === null) {
    warnings.push({
      warningID: 'TW1063',
      type: 'questionnaire',
      subType: 'sourceReductionActivities',
      casOrCategory,
      message: `${chemicalName} (${casOrCategory}), we could not find answers for source reduction activities.`,
      blocksPriorYearSection8Calculation: false,
    });
  }

  const chemicalSpecificActivities = sourceReductionActivities.activities.filter(
    (a) => a.casOrCategory === casOrCategory,
  );
  const isApplicable = sourceReductionActivities.isApplicable && chemicalSpecificActivities.length > 0;
  if (isApplicable) {
    return {
      choice: 'SourceReductionActivity',
      value: chemicalSpecificActivities.map((activity, index): TRISourceReductionActivityDataType => {
        if (activity.activityCode === '') {
          warnings.push({
            warningID: 'TW1022',
            type: 'questionnaire',
            subType: 'sourceReductionActivities',
            casOrCategory,
            message: `${chemicalName} (${casOrCategory}), we did not find an activity code associated with source reduction #${index + 1}.`,
            blocksPriorYearSection8Calculation: false,
          });
        }

        if (activity.methodsToIdentify.length === 0) {
          warnings.push({
            warningID: 'TW1023',
            type: 'questionnaire',
            subType: 'sourceReductionActivities',
            casOrCategory,
            message: `${chemicalName} (${casOrCategory}), we did not find a method codes associated with source reduction #${index + 1}.`,
            blocksPriorYearSection8Calculation: false,
          });
        }

        if (activity.efficiency === '') {
          warnings.push({
            warningID: 'TW1024',
            type: 'questionnaire',
            subType: 'sourceReductionActivities',
            casOrCategory,
            message: `${chemicalName} (${casOrCategory}), we did not find an efficiency code associated with source reduction #${index + 1}.`,
            blocksPriorYearSection8Calculation: false,
          });
        }

        return {
          SourceReductionSequenceNumber: index + 1,
          SourceReductionActivityCode: activity.activityCode,
          SourceReductionMethodCode: activity.methodsToIdentify,
          SourceReductionEfficiencyCode: activity.efficiency,
        };
      }),
    };
  } else {
    return {
      choice: 'NA',
      value: true,
    };
  }
}
